import { render } from "./cardType.vue?vue&type=template&id=0390267c&scoped=true"
import script from "./cardType.vue?vue&type=script&lang=js"
export * from "./cardType.vue?vue&type=script&lang=js"

import "./cardType.vue?vue&type=style&index=0&id=0390267c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0390267c"

export default script